











































import Vue from 'vue'

export default Vue.extend({
  name: 'AppPagination',
  props: {
    totalItems: {
      required: false,
      type: Number,
      default: null
    },
    totalPages: {
      required: true,
      type: Number
    },
    currentPage: {
      required: false,
      type: Number,
      default: 1
    },
    itemsPerPage: {
      required: true,
      type: Number
    },
    pagerConfig: {
      required: false,
      type: Object,
      default: () => ({ newRoute: 'push' })
    }
  },
  data () {
    return {
      perPage: '10',
      perPageValues: [10, 30, 50]
    }
  },
  methods: {
    changePage (event: any) {
      if (event !== this.currentPage) {
        this.$emit('onChangePage', event, this.pagerConfig)
      }
    },
    changePerPage () {
      this.$emit('onChangePerPage', Number(this.perPage))
    }
  }
})
